/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import colorUtils from 'color';

type Props = {
  value: number,
};

const GraphContainer = glamorous.div({
  display: 'flex',
  height: '1.1em',
  justifyContent: 'center',
  alignItems: 'flex-end',
});

const Column = glamorous.div(({ theme }) => ({
  width: 6,
  marginRight: 2,
  backgroundColor: theme.color.basis6,
}));

const Column1 = glamorous(Column)(({ theme, color }) => ({
  height: '25%',
  backgroundColor:
    color &&
    colorUtils(theme.color.primary)
      .alpha(0.4)
      .string(),
}));

const Column2 = glamorous(Column)(({ theme, color }) => ({
  height: '50%',
  backgroundColor:
    color &&
    colorUtils(theme.color.primary)
      .alpha(0.6)
      .string(),
}));

const Column3 = glamorous(Column)(({ theme, color }) => ({
  height: '75%',
  backgroundColor:
    color &&
    colorUtils(theme.color.primary)
      .alpha(0.8)
      .string(),
}));

const Column4 = glamorous(Column)(({ theme, color }) => ({
  height: '100%',
  backgroundColor: color && theme.color.primary,
}));

function Graph({ value }: Props) {
  return (
    <GraphContainer>
      <Column1 color={value > 0.2} />
      <Column2 color={value > 0.4} />
      <Column3 color={value > 0.6} />
      <Column4 color={value > 0.8} />
    </GraphContainer>
  );
}

export default Graph;
